import { useNavigate, useLocation } from "react-router";
import BoardItem from "./BoardItem";
import BoardNoneItem from "./BoardNoneItem";
import SupportPanel from "./SupportPanel";
import { IOccurrence } from "../types";
import { ContentLoader, NotFoundState } from "@rio-cloud/rio-uikit";

interface Props {
    data: IOccurrence[];
    isLoading: boolean;
}

const ListBoard = ({ data, isLoading }: Props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleClickItem = (id: number | string) => {
        navigate({
            pathname: location.pathname + '/details',
            search: `?id=${id}`,
        });
    };

    const STATUS_ORDER = ["OPEN", "IN_ANALYSIS", "ANSWERED", "FINISHED"];

    return (
        <div className="margin-top-15 bg-white padding-15">
            <div className="width-100pct height-100pct display-flex flex-column" style={{ background: '#D0DAE2', padding: 10 }}>
                <div className="display-flex width-100pct">
                    <div className="width-25pct">
                        <SupportPanel title="Abertura do chamado" />
                    </div>
                    <div className="width-25pct">
                        <SupportPanel title="Análise VWCO" />
                    </div>
                    <div className="width-25pct">
                        <SupportPanel title="Respondido ao dealer" />
                    </div>
                    <div className="width-25pct">
                        <SupportPanel title="Finalizado" />
                    </div>
                </div>

                {isLoading ? Array.from(({ length: 2 })).map((_, l) => {
                    return (
                        <div key={l?.toString()} className="display-flex margin-bottom-10">
                            {Array.from({ length: STATUS_ORDER.length }).map((_, idx) => {
                                return (
                                    <div className="width-25pct height-200" key={idx?.toString()}>
                                        <ContentLoader className="width-100pct height-100pct border" />
                                    </div>
                                )
                            })}
                        </div>
                    )
                }) : null}

                {!isLoading && data?.length ? (
                    <div className="flex-column">
                        {data.map((item: IOccurrence, idx: number) => {
                            const order = STATUS_ORDER?.indexOf(
                                item.status
                            );
                            
                            return (
                                <div className="display-flex margin-bottom-10" key={idx.toString()}>
                                    {Array.from({ length: STATUS_ORDER.length }).map((col, colIdx) => (
                                        <div className="width-25pct" key={colIdx}>
                                            {colIdx === order ? (
                                                <BoardItem onClick={() => handleClickItem(item?.id)} data={item} />
                                            ) : (
                                                <BoardNoneItem />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                ) : null}

                {!isLoading && !data?.length ? (
                    <div className="width-100pct margin-top-10">
                        <NotFoundState
                            headline="Nenhuma ocorrência encontrada"
                            message='Não encontramos solicitações para exibir nesta etapa.'
                            outerClassName='border-none'
                        />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default ListBoard;